import {deviceType, appStoreType} from '../const/UserDeviceConst';

export const isMobile = {
  AmazonFire() {
    return !!navigator.userAgent.match(/Kindle Fire|Silk/i);
  },
  Android() {
    return !!navigator.userAgent.match(/Android/i);
  },
  BlackBerry() {
    return !!navigator.userAgent.match(/BlackBerry/i);
  },
  iOS() {
    return !!(navigator.userAgent.match(/iPhone|iPad|iPod/i) || navigator.platform.match(/iPhone|iPad|iPod/i));
  },
  iPhone() {
    return !!navigator.userAgent.match(/iPhone/i);
  },
  Opera() {
    return !!navigator.userAgent.match(/Opera Mini/i);
  },
  Windows() {
    return !!(navigator.userAgent.match(/Windows Phone/i) || navigator.userAgent.match(/IEMobile/i || navigator.userAgent.match(/WPDesktop/i)));
  },
  any() {
    return (isMobile.AmazonFire() ||
      isMobile.Android() ||
      isMobile.BlackBerry() ||
      isMobile.iOS() ||
      isMobile.Opera() ||
      isMobile.Windows());
  },
};

export function getMobileAppStoreType() {
  const type = getDeviceType();

  switch (type) {
    case deviceType.amazonFire:
      return appStoreType.amazon;
    case deviceType.android:
      return appStoreType.googlePlay;
    case deviceType.ios:
      return appStoreType.appleStore;
    case deviceType.windows:
      return appStoreType.windows;
    default:
      return '';
  }
}

export const detectOs = {
  isWindows: () => {
    return /Win/.test(navigator.platform);
  },
  isLinux: () => {
    return /Linux/.test(navigator.platform);
  },
  isMac: () => {
    return /Mac/.test(navigator.platform);
  }
};

export function getDeviceType() {
  if (isMobile.any()) {
    if (isMobile.iOS()) {
      return deviceType.ios;
    } else if (isMobile.AmazonFire()) {
      return deviceType.amazonFire;
    } else if (isMobile.Android()) {
      return deviceType.android;
    } else if (isMobile.Windows()) {
      return deviceType.windowsPhone;
    }
    return deviceType.otherMobile;
  }

  if (detectOs.isMac()) {
    return deviceType.mac;
  } else if (detectOs.isLinux()) {
    return deviceType.linux;
  } else if (detectOs.isWindows()) {
    return deviceType.windows;
  }
  return deviceType.otherDesktop;
}

export function getUrlQueryParameters(str) {
  return (str || document.location.search).replace(/(^\?)/, '').split('&').map(function (n) {
    n = n.split('=');
    this[n[0]] = n[1];
    return this;
  }.bind({}))[0];
}

/**
 * Returns true if element is fully visible in viewport (whole bounding rectangle)
 */
export function isElementVisibleInViewport(el) {
  if (!el) {
    return false;
  }

  const rect = el.getBoundingClientRect();
  return (
    rect.width &&
    rect.height &&
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

/**
 * Returns true if element is at least partially visible in viewport
 */
export function isElementPartiallyVisibleInViewport(el) {
  const rect = el.getBoundingClientRect();

  return rect.bottom > 0 &&
      rect.right > 0 &&
      rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
      rect.top < (window.innerHeight || document.documentElement.clientHeight);
}

export function isElementVisible(elem) {
  return elem.clientWidth !== 0 && elem.clientHeight !== 0;
}

export function isElementOrItsChildrenVisible(elem) {
  if (isElementVisible(elem)) return true;
  for (const child of elem.children) {
    if (isElementVisible(child)) return true;
  }
  return false;
}

export function isElementOrItsChildrenVisibleInViewport(elem) {
  if (isElementPartiallyVisibleInViewport(elem)) return true;
  for (const child of elem.children) {
    if (isElementPartiallyVisibleInViewport(child)) return true;
  }
  return false;
}

